import React, { useEffect } from "react";
import { useHistory, withRouter } from "react-router-dom";

const TimeSeriesComponent = (props) => {
  const history = useHistory();

  useEffect(() => {
    (async () => {
      await localStorage.setItem("skygeni-user-page", "Enhanced Insights");
      await localStorage.setItem(
        "skygeni-user-enhancedPage",
        "Time Series projection of Closed Won"
      );
      await localStorage.removeItem("skygeni-user-repPage");
      await localStorage.setItem(
        "params",
        JSON.stringify(props.match.params.filters)
      );
      history.push("/");
      window.location.reload();
    })();
  }, []);

  return <div style={{ margin: "1rem auto" }}>Loading...</div>;
};
let routerAddedTimeSeriesComponentComponent = withRouter(
    TimeSeriesComponent
);
export default routerAddedTimeSeriesComponentComponent;
